// Estandar VRTC: contratos verificables auto-calculados por cada componente.
// Registro por sesion: cada componente que pinta cifras registra su contrato al montarse,
// de modo que readAllContracts() devuelve la union de lo visto en la navegacion + el DOM actual.

const registro = new Map();

export function verifyAttrs(obj) {
  const out = {};
  if (obj && obj.unit) out['data-verify-unit'] = obj.unit;
  for (const [k, v] of Object.entries(obj || {})) {
    if (k === 'unit') continue;
    out[`data-verify-${k}`] = typeof v === 'boolean' ? String(v) : String(v);
  }
  return out;
}

// Registra/actualiza el contrato de un componente (unit unico).
export function registerContract(unit, { campos = {}, reglas = {} } = {}) {
  registro.set(unit, {
    unit,
    campos: Object.fromEntries(Object.entries(campos).map(([k, v]) => [k, String(v)])),
    reglas: Object.fromEntries(Object.entries(reglas).map(([k, v]) => [k, v === true || v === 'true'])),
  });
}

function leerDelDOM() {
  const mapa = new Map();
  document.querySelectorAll('[data-verify-unit]').forEach((n) => {
    const unit = n.getAttribute('data-verify-unit');
    const contrato = { unit, campos: {}, reglas: {} };
    for (const attr of n.attributes) {
      if (!attr.name.startsWith('data-verify-')) continue;
      const nombre = attr.name.replace('data-verify-', '');
      if (nombre === 'unit') continue;
      if (nombre.endsWith('-cuadra')) contrato.reglas[nombre] = attr.value === 'true';
      else contrato.campos[nombre] = attr.value;
    }
    mapa.set(unit, contrato);
  });
  return mapa;
}

export function readAllContracts() {
  const merged = new Map(registro);
  leerDelDOM().forEach((v, k) => merged.set(k, v)); // el DOM vivo tiene prioridad
  const contratos = [...merged.values()];
  const fallos = contratos.filter((c) => Object.values(c.reglas).some((v) => v === false));
  const resumen = { total: contratos.length, fallos: fallos.length, contratos };
  // eslint-disable-next-line no-console
  console.table(contratos.map((c) => ({ unit: c.unit, ...c.reglas })));
  return resumen;
}

if (typeof window !== 'undefined') {
  window.readAllContracts = readAllContracts;
  window.registerContract = registerContract;
}
